import { Component, inject, type OnInit } from '@angular/core';
import { TitleService } from '../title.service';

@Component({
  selector: 'app-super-admin',
  templateUrl: './super-admin.component.html',
  styleUrls: ['./super-admin.component.scss'],
  standalone: false,
})
export class SuperAdminComponent implements OnInit {
  private titleService = inject(TitleService);

  ngOnInit() {
    this.titleService.set('Super admin');
  }
}
